module.exports = __webpack_public_path__ + "static/WT_Interaction_Card-d6981ee175bd56b88e391ba55d8921bc.png";